// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__XxRX-","requiredAsterisk":"Info_requiredAsterisk__3U6li"};